import { Message } from 'element-ui';
import axios from 'axios';
import qs from 'qs';
// import router from '@/routers';
import UtilCache from './cache';
// 埋点
import Metrics from '@dap/monitor/metrics';

const instance = axios.create({
    // 调试专用, 如果发现baseURL不为空, 需要清空
    // baseURL: 'http://dap-ad3.adqa.lilith.sh',
    baseURL: '',
    // baseURL: 'http://dap.lilithgame.com',
    timeout: 900000,
});

const requestWithToken = (config) => {
    let token = UtilCache.getLocalItem('token');
    if (!!token) {
        config.headers['Authorization'] = `Basic ${token}`;
    } else {
        window.location.path = '/login';
    }

    config.headers['Accept-version'] = '1.0';
    let version = UtilCache.getLocalItem('version');
    if (!!version) {
        config.headers['Accept-version'] = version;
    }

    config.headers['Cache-Control'] = 'no-cache';

    return config;
};

let oldTimestamp = null;
let isSingleMsg = false;
let singleTimer = null;

// 每次请求都带上token
instance.interceptors.request.use(
    (config) => {
        // // todo 为了减少测试的报错信息，暂时过滤工作表下的所有拦截逻辑，但上线前必须去掉
        // const isTable = window.location.href.indexOf('/table-2') > -1;
        // if (!pendingUrlWhitelist.includes(config.url) && !isTable) {

        //自定义 Axios 请求的参数序列化过程
        if(config.method === 'get'){
            config.paramsSerializer = function (params) {
                const newParams = JSON.parse(JSON.stringify(params));
                delete newParams.fixParams;
                // GET请求的参数中有值为null或undefined的属性，axios默认会自动将这些属性过滤掉，这里手动过滤
                for (let key in newParams) {
                    if ((newParams.hasOwnProperty(key) && newParams[key] === null) || newParams[key] === undefined) {
                        delete newParams[key];
                    }
                }
                // console.log('paramsSerializer--',params,newParams);
                return qs.stringify(newParams,{arrayFormat:'brackets'});
            };
        }

        if (!pendingUrlWhitelist.includes(config.url)) {
            // console.log('config',config);
            removePending(config);
            addPending(config);
        }

        config = requestWithToken(config);
        // 处理 post|delete|put 请求，以formdata形式传参
        if (['post', 'delete', 'put'].includes(config.method)) {
            for (let key in config.data) {
                if ((config.data.hasOwnProperty(key) && config.data[key] === null) || config.data[key] === undefined) {
                    delete config.data[key];
                }
            }
            if (!config.headers.hasOwnProperty('Content-Type')) {
                config.data = qs.stringify(config.data);
                config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            }

            if(['post', 'put'].includes(config.method)){
                //自定义data序列化过程
                config.transformRequest = [function (data, headers) {
                    if (data instanceof FormData) {
                        const newFormData = new FormData();
                        data.forEach((value, key) => {
                            if (key !== 'fixParams') {
                                newFormData.append(key, value);
                            }
                        });
                        return newFormData;
                    }

                    const newData = JSON.parse(JSON.stringify(data));
                    delete newData.fixParams;

                    if (headers?.['Content-Type'] === 'application/json') {
                        return JSON.stringify(newData);
                    }

                    return data;
                }];
            }



        }
        oldTimestamp = performance.now();
        return config;
    },
    (error) => {
        oldTimestamp = performance.now();
        return Promise.reject(error);
    }
);

// 处理返回结果
instance.interceptors.response.use(
    (response) => {
        Metrics.apiReport(response, oldTimestamp);
        // // todo 为了减少测试的报错信息，暂时过滤工作表下的所有拦截逻辑，但上线前必须去掉
        // const isTable = window.location.href.indexOf('/table-2') > -1;
        // if (!pendingUrlWhitelist.includes(response.url) && !isTable) {
        if (!pendingUrlWhitelist.includes(response.url)) {
            removePending(response.config);
        }
        return response;
    },
    (error) => {
        oldTimestamp = performance.now();
        if (axios.isCancel(error)) {
            // errorReport2(error);
            // console.log('repeated request: ' + error.message);
            // return Promise.reject(error.message);
        }

        if (error.response) {
            errorReport(error.response);

            if ([404, 502, 500].includes(error.response.status)) {
                Message({
                    message: `${error.response.status} ${error.response.statusText}`,
                    type: 'error',
                });
            } else if (error.response.status === 401) {
                console.log('main http');
                // TODO YO 待修改
                // UtilCache.setLocalItem('from', router.currentRoute.fullPath);
                // router.replace({ name: 'Login' });
                // 微前端特殊处理
                const fullPath = window.location.pathname + window.location.search + window.location.hash;
                if (!fullPath.includes('login')) {
                    // token失效
                    UtilCache.removeLocalAll();
                    UtilCache.setLocalItem('from', fullPath);
                    history.pushState(null, '登录', '/login');
                    window.location.reload();
                }
            } else if (error.response.status === 400) {
                // 参数缺失
                let message = error.response.data['msg' || 'message'];
                if (Object.prototype.toString.call(message) === '[object Object]') {
                    message = `参数缺失：${Object.keys(message)[0]}`;
                }
                Message({
                    message: `${error.response.status} ${message}`,
                    type: 'error',
                });
            } else if (error.response.status === 417) {
                // 表单的参数错误
                // 实时校验，将在业务代码中用try...catch...处理。
                // 这里不做任何处理
            } else {
                if (isSingleMsg) {
                    // api 超时，手动上报 http code
                    if (error.response) {
                        Metrics.httpErrorReport(error, oldTimestamp);
                    }
                    // 返回接口返回的错误信息
                    return Promise.reject(error?.response);
                }

                Message({
                    message: error.response.data.message || error.response.data.msg,
                    type: 'error',
                });
                isSingleMsg = true;
                singleTimer = setTimeout(() => {
                    isSingleMsg = false;
                    clearTimeout(singleTimer);
                    singleTimer = null;
                }, 3000);
            }
        } else if (error.code === 'ECONNABORTED') {
            Message({
                message: '请求超时，请稍后再试',
                type: 'error',
            });
        }
        // api 超时，手动上报 http code
        if (error.response) {
            Metrics.httpErrorReport(error, oldTimestamp);
        }
        // 返回接口返回的错误信息
        return Promise.reject(error?.response);
    }
);

const errorReport = (res) => {
    const isProd = window.location.hostname === 'dap.lilithgame.com';
    // 追踪链接中 广告组的名称校验
    const isTracklinkGroupUrl = res.config.url === '/dapper/api/adgroups/check';
    const isIgnoredCodes = [404, 408, 403, 502, 503, 500, 401, 406, 417, 410].includes(res.status);
    // const isBusinessError = res.status === 410 && (/【.*?】/.test(res.data.msg) || /【.*?】/.test(res.data.message));

    if (!isProd || isTracklinkGroupUrl || isIgnoredCodes) {
        return;
    }

    const userInfo = UtilCache.getLocalItem('userInfo');
    const data = {
        msg_type: 'text',
        content: {
            text:
                `${res.config.method}  ${res.config.url}\n\n` +
                `${res.status}  ${res.statusText}\n\n` +
                `报错信息: ${JSON.stringify(res.data.msg || res.data.message || '无')}\n\n` +
                `浏览器UA: ${navigator.userAgent}\n\n` +
                `用户id: ${userInfo.id}  用户名称: ${userInfo.name}\n\n` +
                `params: ${decodeURIComponent(JSON.stringify(res.config.params || res.config.data))}\n\n` +
                `地址: ${location.toString()}\n\n` +
                `${JSON.stringify(res.config.headers)}`,
        },
    };

    fetch('/qywx/open-apis/bot/v2/hook/e937b51f-0604-4e15-8f93-7b7934530e1e', {
        body: JSON.stringify(data),
        headers: {
            'content-type': 'application/json',
        },
        method: 'POST',
    })
        .then(() => {})
        .catch(() => {});
};

const generatePendingKey = (config) => {
    let fixParams = {};
    if (config.method === 'get') {
        const params = config.params || {};
        fixParams = params.fixParams || {};
    } else if (['post', 'put'].includes(config.method)) {
        const data = config.data || {};
        fixParams = data.fixParams || {};
    }

    const fixParamsStr = Object.keys(fixParams).length > 0
        ? qs.stringify(fixParams)
        : '';
    return Object.keys(fixParams).length > 0 ? [config.method, config.url, fixParamsStr].join('&') : [config.method, config.url].join('&');
};

// 取消重复的请求
const pending = new Map();

const addPending = (config) => {
    const pendingKey = generatePendingKey(config);
    console.log('pendingkey:',pendingKey);
    config.cancelToken =
        config.cancelToken ||
        new axios.CancelToken((cancel) => {
            if (!pending.has(pendingKey)) {
                pending.set(pendingKey, cancel);
            }
        });
};

const removePending = (config) => {
    const pendingKey = generatePendingKey(config);
    if (pending.has(pendingKey)) {
        const cancel = pending.get(pendingKey);
        cancel(pendingKey);
        pending.delete(pendingKey);
    }
};

// 清空 pending 中的请求（在路由跳转时调用）
export const clearPending = () => {
    for (const [url, cancel] of pending) {
        cancel(url);
    }
    pending.clear();
};

const pendingUrlWhitelist = [
    '/dapper/api/insights/active/old_ret',
    '/dapper/api/insights/active/old_ret_rate',
    '/dapper/api/insights/weekly/roi',
    '/dapper/api/insights/weekly/overview',
    '/dapper/api/insights/custom_insight/runtime/rt60',
    // '/dapper/api/insights/custom_insight/retain/analysis',
    '/dapper/api/acc/conversions',
    // '/dapper/api/creative',
    '/dapper/api/review/prohibited_sensitive_words',
    // '/dapper/api/review/reviews',
    '/dapper/api/insights/observatory/finance/dap/detail_graph',
    '/dapper/api/insights/observatory/finance/fin/detail_graph',
    '/dapper/api/insights/observatory/finance/dap/detail_graph_v2',
    '/dapper/api/insights/observatory/finance/fin/outcome_level_detail_graph',
    '/dapper/api/insights/observatory/finance/fin/profit_rate_graph',
    '/dapper/api/insights/observatory/finance/fin/mini_profit_rate',
    '/dapper/api/finance-v2/gxt_finance/min_budget_month',
    '/dapper/api/insights/observatory/key_indicator',
    '/dapper/api/insights/observatory/key_indicator_v2',
    '/dapper/api/insights/observatory/key_indicator_graphs/pay_count',
    '/dapper/api/creative/word',
    '/dapper/api/ad/common',
    '/dapper/api/insights/observatory/finance/dap/profit_rate_graph',
    '/dapper/api/insights/observatory/finance/fin/outcome_level_detail_graph',
    '/dapper/api/insights/observatory/finance/dap/outcome_level_detail_graph_v2',
    '/dapper/api/materiel_2/tags',
    '/dapper/api/mat/general/user',
    '/dapper/api/materiel_2/covers',
    '/dapper/api/insights/portrait/cl/region',
    '/dapper/api/insights/portrait/cl/country',
    '/dapper/api/insights/portrait/cl/lang',
    '/dapper/api/insights/custom_insight/portrait/pie_chart',
    '/dapper/api/insights/custom_insight/retain/region',
    '/dapper/api/insights/custom_insight/retain/login_quality',
    '/dapper/api/aud/tt_ad/audiences',
    '/dapper/api/gdt_ad/sites',
    '/dapper/api/gdt_ad/estimation',

    '/dapper/api/mansion/act_advanced_screen',
    '/dapper/api/mansion/ic_advanced_screen',
    '/dapper/api/mansion/master_advanced_screen',
    '/dapper/api/mansion/spreader_advanced_screen',
    '/coach/api/ad_packages',

    '/dapper/api/materiel_2/edit',
    '/dapper/api/materiel_2/list',
    '/dapper/api/materiel_2/material-dict',
    '/dapper/api/materiel_2/material-dict_v2',
    '/dapper/api/materiel_2/material-info-preview',
    '/coach/api/tag_config/tag_list',
    '/coach/api/tag_config/tag',

    '/dapper/api/toutiao_ad/campaign/update_status',
    '/dapper/api/toutiao_ad/adgroup/update_status',
    '/dapper/api/toutiao_ad/ad/update_status',

    '/dapper/api/gdt_ad/campaign/update_status',
    '/dapper/api/gdt_ad/adgroup/update_status',
    '/dapper/api/gdt_ad/ad/update_status',

    '/dapper/api/fb_ad/campaign/update_status',
    '/dapper/api/fb_ad/adgroup/update_status',
    '/dapper/api/fb_ad/ad/update_status',

    '/dapper/api/cus/entrys',

    // 请求时间比较长的字典
    '/coach/api/game_ad_type',
    '/dapper/api/aud/fb_dict',
    // 快手创意选择多个创意，防止请求被取消
    '/dapper/api/creative/kuaishou/check',
    '/dapper/api/kuaishou_ad/ad/checkname',

    // 观星台 游戏大盘 多个游戏
    // '/dapper/api/insights/games-pane/daily',
    // '/dapper/api/insights/games-pane/month',
    '/dapper/api/insights/games-pane/runtime/rt60',
    '/dapper/api/insights/game_lc/country/top5',
    // '/dapper/api/insights/games-pane/remkt/daily',
    // '/dapper/api/insights/games-pane/remkt/month',
    '/dapper/api/insights/games-pane/remkt/runtime/rt60',

    // '/dapper/api/insights/games-pane/runtime/rt5',
    // '/dapper/api/insights/games-pane/remkt/runtime/rt5',

    // 衍生分类
    '/coach/api/material_derivation/derived_classification',
    // 头条-批量创意盒子（朋友圈-头像及昵称跳转页）
    '/dapper/api/gdt_ad/dap_profiles',

    // 创意库字典
    '/dapper/api/creative/selector',

    //广点通批量扩量种子人群 后期改掉
    '/dapper/api/gdt_ad2/crowds',
    '/dapper/api/creative/tiktok/check',

    // 批量获取自动name
    '/dapper/api/tiktok_ads/autoname/ad',

    // 万花筒上传相关
    '/artascope/api/sts',
    '/artascope/api/object/check_name',
    '/artascope/api/object/check_md5',
    '/artascope/api/object',
    '/artascope/api/object/record',
    '/artascope/api/project/list',
    // 刷新资源 preview_url
    '/artascope/api/object/url',
    // 打包下载
    '/artascope/api/object/zip',
    '/dapper/api/acc/accounts',

    // 脚本管理2.0脚本查询通用接口
    '/dapper/api/material_script/script/list',
    // 脚本管理2.0 脚本首页-所有脚本-不展示创意维度
    '/dapper/api/material_script/script/all_script',
    // 快手定向包
    '/dapper/api/aud/crowds',
    '/dapper/api/aud/crowd/filter',
    // 头条2定向包
    '/dapper/api/aud/action_interest/category',

    '/dapper/api/acc/v2/default_account',

    // 人群包-素材命名
    '/coach/api/materials',
    // 单条广告回填关键字
    '/dapper/api/keyword/asa/keywords',
    // 报表，筛选回填广告
    '/dapper/api/toutiao_ad3/promotion',
    // 人群洞察
    '/api/clickhouse/crowd-analyse/tag/scatter',
     // 广点通流量包查询接口
    '/dapper/api/gdt_ad2/union_position_packages/get',
    // 退出登录
    '/user/api/user/logout',
];

export const postJson = (url, data, option = {}) =>
    instance.post(url, data, {
        headers: { 'Content-Type': 'application/json' },
        ...option,
    });

export const putJson = (url, data) =>
    instance.put(url, data, {
        headers: { 'Content-Type': 'application/json' },
    });

export const deleteJson = (url, data) =>
    instance.delete(url, data, {
        headers: { 'Content-Type': 'application/json' },
    });

//新增取消请求方法
export const getCancelJson = (url, data, fixParams = {}) => {
    const params = {
        ...data,
        fixParams :fixParams
    };
    return instance.get(url,{ params });
};

export const postCancelJson = (url, data, fixParams = {}) => {
    const params = {
        ...data,
        fixParams :fixParams
    };
    return instance.post(url,params);
};

export const putCancelJson = (url, data, fixParams = {}) => {
    const params = {
        ...data,
        fixParams :fixParams
    };
    return instance.put(url,params);
};



export default instance;
